<template>
    <div ref="listWrap" class="list" @click="markInteraction" @focusin="markInteraction" @focusout="onFocusout($event)" v-clickoutside="changeToViewerAll" tabindex="-1" style="outline: none">
        <h3 class="st">{{$t('enrolmentEditorQuestionList_enrolmentPrograms')}}</h3>

        <template v-for="(question, index) in questions">
            <template v-if="(index === 0 && activeEditorIndex === -2) || index === activeEditorIndex">
                <EnrolmentQuestionEditor
                    :ref="`question:${index}`"
                    :question-index="index"
                    @copyQuestion="onCopyQuestion"
                    :key="question.questionNo"
                />
                <div class="btn_move_area">
                    <button
                        ref="upButton"
                        type="button"
                        class="b_up"
                        @click.prevent="moveUpQuestion(index)"
                        v-ga-helper:click="{
                            view_category: '수강신청프로그램',
                            view_area: '위로이동클릭',
                            view_label: '',
                        }"
                    >
                      {{$t('enrolmentEditorQuestionList_moveUp')}}
                    </button>
                    <button
                        ref="downButton"
                        type="button"
                        class="b_dn"
                        @click.prevent="moveDownQuestion(index)"
                        v-ga-helper:click="{
                            view_category: '수강신청프로그램',
                            view_area: '아래로이동클릭',
                            view_label: '',
                        }"
                    >
                      {{$t('enrolmentEditorQuestionList_moveDown')}}
                    </button>
                </div>
            </template>
            <EnrolmentQuestionViewer :ref="`question:${index}`" v-else :question-index="index" :key="question.questionNo" @changeActiveEditor="onChangeActiveEditor"/>
        </template>

        <div class="bx_btn">
            <button
                type="button"
                class="btn2"
                @click.prevent="addQuestion"
                v-ga-helper:click="{
                    view_category: '수강신청프로그램',
                    view_area: '수강신청추가하기클릭',
                    view_label: '',
                }"
            >{{$t('enrolmentEditorQuestionList_addEnrolment')}}</button>
        </div>
    </div>
</template>
<script>
    import {mapFields, mapMultiRowFields} from "vuex-map-fields";
    import EnrolmentQuestionEditor from "@/iamteacherpc/components/editor/EnrolmentQuestionEditor.vue";
    import EnrolmentQuestionViewer from "@/iamteacherpc/components/editor/EnrolmentQuestionViewer.vue";
    import {ADD_QUESTION, MAX_QUESTION,} from "@/common/store/modules/enrolment/editor.js";
    import {mapActions} from "vuex";
    import editorQuestionList from "@/iamteacherpc/mixins/editorQuestionList.js";
    import {
        LIST_CHANGE,
        MOVE_DOWN_QUESTION,
        MOVE_UP_QUESTION,
        STOP_LIST_CHANGE
    } from "@/common/store/modules/common/editor/questionList.js";

    export default {
        name: "EnrolmentEditorQuestionList",
        components: {EnrolmentQuestionEditor, EnrolmentQuestionViewer},
        mixins: [
            editorQuestionList,
        ],

        data() {
            return {
                questionText: this.$t('common_enrolment'),
                maxQuestion: MAX_QUESTION,
            }
        },

        computed: {
            ...mapMultiRowFields('enrolment', ['form.questions']),
            ...mapFields('enrolment', {
                isStopListChange: 'options.stopListChange',
            }),
        },

        methods: {
            ...mapActions('enrolment', {
                storeAddQuestion: ADD_QUESTION,
                storeMoveUpQuestion: MOVE_UP_QUESTION,
                storeMoveDownQuestion: MOVE_DOWN_QUESTION,
                stopListChange: STOP_LIST_CHANGE,
                listChange: LIST_CHANGE
            }),
        },
    }
</script>

<style scoped>

</style>
